export const handleApiError = (error) => {
    if (!error.response) {
      console.error("Network Error:", error.message);
      alert("Network Error. Please check your internet connection.");
      return;
    }
  
    const { status, data } = error.response;
  
    switch (status) {
      case 400:
        console.error("Bad Request:", data.message);
        alert("Bad Request: " + data.message);
        break;
      case 401:
        console.error("Unauthorized:", data.message);
        alert("Unauthorized. Please log in again.");
        localStorage.removeItem("token");

        window.location.href = "/"; // Redirect to login
        break;
      case 403:
        console.error("Forbidden:", data.message);
        alert("You don't have permission for this action.");
        break;
      case 404:
        console.error("Not Found:", data.message);
        alert("Requested resource not found.");
        break;
      case 500:
        console.error("Server Error:", data.message);
        alert("Internal Server Error. Please try again later.");
        break;
      default:
        console.error("Error:", data.message);
        alert(data.message || "An error occurred.");
    }
  };
  